import {
  DEVIS_STATUS,
} from "modules/devis/types/devis.interface";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Autocomplete, Option } from "components/fields/autoCompleteField";


export interface SelectStatusProps {
  value: DEVIS_STATUS;
  onChange: (status: DEVIS_STATUS) => void;
}

export const statusLabels: Record<DEVIS_STATUS, string> = {
  [DEVIS_STATUS.DRAFT]: "📝 En cours",
  [DEVIS_STATUS.VALIDATED]: "👍 Validé",
  [DEVIS_STATUS.SENT]: "📨 Envoyé",
  [DEVIS_STATUS.REJECTED]: "🚫 Rejeté",
  [DEVIS_STATUS.ACCEPTED]: "✅ Accepté",
};

export const SelectStatus: FunctionComponent<SelectStatusProps> = ({
  value,
  onChange,
}) => {
  const options: Option[] = useMemo(
    () =>
      Object.values(DEVIS_STATUS).map((status) => ({
        id: status,
        name: statusLabels[status],
      })),
    []
  );
  
  // Initialize searchValue based on the current value
  const initialValue = value ? statusLabels[value] : "";
  const [searchValue, setSearchValue] = useState<string>(initialValue);

  const handleOptionChange = (optionValue: Option) => {
    onChange(optionValue.id as DEVIS_STATUS);

    // Déclencher une action spécifique ici
    triggerSpecificAction(optionValue.id as DEVIS_STATUS);
  };

  // Update searchValue whenever value changes (including API fetch)
  useEffect(() => {
    if (value) {
      const status = options.find((option) => option.id === value);
      if (status) {
        setSearchValue(status.name);
      }
    }
  }, [value, options]);

  if (options.length < 1) return null;

  return (
    <Autocomplete
      options={options}
      onSelect={handleOptionChange}
      value={value ? [value] : []}
      label="Sélectionner un statut"
      searchValue={searchValue}
      setSearchValue={setSearchValue}
    />
  );
};

// Fonction pour déclencher une action spécifique
const triggerSpecificAction = (status: DEVIS_STATUS) => {
  // Logique pour l'action spécifique
  console.log(`Statut changé à : ${status}`);
};
